export default __webpack_public_path__ + "static/media/truckBgWhite.9800bacd.png";